/* istanbul ignore file */
import { Location } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { dashboardRouteWithSlash, myAccountRouteWithSlash } from '../../../route-constants';

@Component({
  selector: 'app-text-hero',
  templateUrl: './text-hero.component.html',
  styleUrls: ['./text-hero.component.scss']
})
export class TextHeroComponent implements OnInit {
  constructor(private location: Location) { }
  @Input() size = '';
  @Input() title = '';
  @Input() ctaText = '';
  @Input() backBtnUrl: string = myAccountRouteWithSlash;
  @Input() backBtnText = 'Main Account';
  @Input() useBackHistory = false;
  @Input() icon: string;
  @Input() shouldRedirectToHome = false;
  ngOnInit(): void {
    if (this.shouldRedirectToHome) {
      this.backBtnUrl = dashboardRouteWithSlash;
    }
  }

  back(): void {
    this.location.back();
  }
}
